import React from 'react';
import { formatMaintenanceEndTime } from './formatMaintenanceEndTime';
import styles from './MaintenancePage.module.css';

export const MaintenancePage: React.FC<{ endTime?: string }> = ({ endTime }) => {
  const formattedEndTime = formatMaintenanceEndTime(endTime);

  return (
    <main className={styles.page}>
      <section className={styles.panel} aria-live="polite">
        <p className={styles.eyebrow}>Scheduled maintenance</p>
        <h1 className={styles.title}>
          This website is temporarily unavailable while we carry out some essential maintenance.
        </h1>
        <p className={styles.body}>We apologise for the inconvenience.</p>
        <p className={styles.timing}>
          {formattedEndTime
            ? `Maintenance will end at ${formattedEndTime.endTime} on ${formattedEndTime.endDate}. Please try completing your training after this.`
            : 'Please try again in a moment.'}
        </p>
      </section>
    </main>
  );
};
